// admin/src/lib/errors.ts
//
// Friendly messages for the Postgres errors this site expects to hit by
// name (admin_grant's "no Calyard account uses %" / P0002, a storage
// `restrict` FK violation when archiving in-use equipment, etc.) --
// everything else falls back to the raw message.

export function friendlyErrorMessage(error: unknown): string {
  const raw = error instanceof Error ? error.message : String(error);

  if (/no Calyard account uses/i.test(raw)) {
    return 'No Calyard account uses that email yet. Ask them to sign up in the app first, then add them here.';
  }
  if (/you cannot remove yourself/i.test(raw)) {
    return "You can't remove your own admin access.";
  }
  if (/not an admin/i.test(raw)) {
    return "This account isn't an admin.";
  }
  if (/violates foreign key constraint/i.test(raw) && /equipment/i.test(raw)) {
    return "This equipment is used by one or more exercises, so it can't be deleted. Archive it instead.";
  }
  if (/violates foreign key constraint/i.test(raw)) {
    return "This item is still referenced elsewhere, so it can't be deleted.";
  }
  if (/duplicate key value violates unique constraint/i.test(raw) && /equipment_pkey/i.test(raw)) {
    return 'That id is already in use.';
  }
  if (/duplicate key value violates unique constraint/i.test(raw) && /media_slots_pkey/i.test(raw)) {
    return 'That slot id already exists.';
  }
  if (/violates row-level security policy/i.test(raw)) {
    return "You don't have permission to do that.";
  }
  if (/Invalid login credentials/i.test(raw)) {
    return 'Incorrect email or password.';
  }
  return raw;
}
